import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 py-24">
        <div className="text-center max-w-lg">
          <span className="font-heading text-8xl md:text-9xl font-black text-background-300 select-none">404</span>
          <h1 className="mt-4 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            这个页面走丢了
          </h1>
          <p className="mt-3 text-sm md:text-base text-foreground-600 font-body leading-relaxed">
            你访问的地址可能已经调整或不存在。可以回到首页，或者直接去清单库找你要的那份避雷清单。
          </p>
          <p className="mt-2 text-xs text-foreground-400 font-label">{location.pathname}</p>
          <div className="mt-7 flex flex-col sm:flex-row justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-label text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-4-line"></i>
              返回首页
            </Link>
            <Link
              to="/guides"
              className="inline-flex items-center justify-center gap-2 rounded-md border border-background-300 px-5 py-3 text-sm font-label text-foreground-800 hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              <i className="ri-shield-check-line"></i>
              浏览避雷清单
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}